<template>
    <div>
        <v-dialog v-model="email_dialog" fullscreen transition="dialog-bottom-transition" overlay="false" scrollable>
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-btn icon @click="email_dialog = false" dark>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Compose Email</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn @click="sendEmail">Send</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="emailForm">
                        <v-container>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <bc-combobox
                                        :focus="email_dialog"
                                        v-model="to_displayed_email"
                                        :label="$t('lang.select_email')"
                                        :items="people_options"
                                        item-text="combined_name"
                                        item-value="primary_email_address"
                                        :filter="email_filter"
                                        :search-input.sync="to_search"
                                        :rules="ifValid('email_info.to')"
                                        hide-selected
                                        multiple
                                        chips
                                        @input="validateEmail($event, 'to')"
                                    >
                                        <template slot="no-data">
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        {{ $t("lang.no_results_matching") }} "<strong>{{ to_search }}</strong
                                                        >". {{ $t("lang.email_add_front") }}
                                                        <kbd class="cursor-text" :class="validNewEmail('to') ? 'bg-success' : 'bg-danger'">{{
                                                            $t("lang.enter_key")
                                                        }}</kbd>
                                                        {{ $t("lang.email_add_end") }}
                                                        <v-icon :color="validNewEmail('to') ? 'success' : 'error'">{{
                                                            validNewEmail("to") ? "check" : "close"
                                                        }}</v-icon>
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </template>
                                        <template slot="selection" slot-scope="data">
                                            <v-chip :selected="data.selected" close class="chip--select-multi pa-2" @input="remove(data.item, 'to')">
                                                <v-avatar>
                                                    <img :src="data.item.photo" />
                                                </v-avatar>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{
                                                        data.item.combined_name ? data.item.combined_name : data.item.primary_email_address
                                                    }}</v-list-tile-title>
                                                    <v-list-tile-sub-title v-if="data.item.combined_name" class="pb-1">{{
                                                        data.item.primary_email_address
                                                    }}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </v-chip>
                                        </template>
                                        <template slot="item" slot-scope="data">
                                            <template>
                                                <v-list-tile-avatar>
                                                    <img :src="data.item.photo" />
                                                </v-list-tile-avatar>
                                                <v-list-tile-content>
                                                    <v-list-tile-title v-html="data.item.combined_name"></v-list-tile-title>
                                                    <v-list-tile-sub-title v-html="data.item.primary_email_address"></v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </template>
                                        </template>
                                    </bc-combobox>
                                </v-flex>
                                <v-flex xs12 style="display: flex; align-items: center; gap: 20px">
                                    <bc-combobox
                                        v-model="cc_displayed_email"
                                        :label="$t('lang.email_cc')"
                                        :items="people_options"
                                        item-text="combined_name"
                                        item-value="primary_email_address"
                                        :search-input.sync="cc_search"
                                        hide-selected
                                        multiple
                                        chips
                                        @input="validateEmail($event, 'cc')"
                                    >
                                        <template slot="no-data">
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        {{ $t("lang.no_results_matching") }} "<strong>{{ cc_search }}</strong
                                                        >". {{ $t("lang.email_add_front") }}
                                                        <kbd class="cursor-text" :class="validNewEmail('cc') ? 'bg-success' : 'bg-danger'">{{
                                                            $t("lang.enter_key")
                                                        }}</kbd>
                                                        {{ $t("lang.email_add_end") }}
                                                        <v-icon :color="validNewEmail('cc') ? 'success' : 'error'">{{
                                                            validNewEmail("cc") ? "check" : "close"
                                                        }}</v-icon>
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </template>
                                        <template slot="selection" slot-scope="data">
                                            <v-chip :selected="data.selected" close class="chip--select-multi pa-2" @input="remove(data.item, 'cc')">
                                                <v-avatar>
                                                    <img :src="data.item.photo" />
                                                </v-avatar>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{
                                                        data.item.combined_name ? data.item.combined_name : data.item.primary_email_address
                                                    }}</v-list-tile-title>
                                                    <v-list-tile-sub-title v-if="data.item.combined_name" class="pb-1">{{
                                                        data.item.primary_email_address
                                                    }}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </v-chip>
                                        </template>
                                        <template slot="item" slot-scope="data">
                                            <template>
                                                <v-list-tile-avatar>
                                                    <img :src="data.item.photo" />
                                                </v-list-tile-avatar>
                                                <v-list-tile-content>
                                                    <v-list-tile-title v-html="data.item.combined_name"></v-list-tile-title>
                                                    <v-list-tile-sub-title v-html="data.item.primary_email_address"></v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </template>
                                        </template>
                                    </bc-combobox>
                                    <label v-if="addBcc != true" @click="addBcc = !addBcc" style="color: blue; text-decoration: underline; cursor: pointer"
                                        >Add BCC</label
                                    >
                                </v-flex>
                                <v-flex v-if="addBcc == true" xs12>
                                    <bc-combobox
                                        v-model="bcc_displayed_email"
                                        :label="$t('lang.email_bcc')"
                                        :items="people_options"
                                        item-text="combined_name"
                                        item-value="primary_email_address"
                                        :search-input.sync="bcc_search"
                                        :rules="ifValid('email_info.displayed_email')"
                                        hide-selected
                                        multiple
                                        chips
                                        @input="validateEmail($event, 'bcc')"
                                    >
                                        <template slot="no-data">
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        {{ $t("lang.no_results_matching") }} "<strong>{{ bcc_search }}</strong
                                                        >". {{ $t("lang.email_add_front") }}
                                                        <kbd class="cursor-text" :class="validNewEmail('bcc') ? 'bg-success' : 'bg-danger'">{{
                                                            $t("lang.enter_key")
                                                        }}</kbd>
                                                        {{ $t("lang.email_add_end") }}
                                                        <v-icon :color="validNewEmail('bcc') ? 'success' : 'error'">{{
                                                            validNewEmail("bcc") ? "check" : "close"
                                                        }}</v-icon>
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </template>
                                        <template slot="selection" slot-scope="data">
                                            <v-chip :selected="data.selected" close class="chip--select-multi pa-2" @input="remove(data.item, 'bcc')">
                                                <v-avatar>
                                                    <img :src="data.item.photo" />
                                                </v-avatar>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{
                                                        data.item.combined_name ? data.item.combined_name : data.item.primary_email_address
                                                    }}</v-list-tile-title>
                                                    <v-list-tile-sub-title v-if="data.item.combined_name" class="pb-1">{{
                                                        data.item.primary_email_address
                                                    }}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </v-chip>
                                        </template>
                                        <template slot="item" slot-scope="data">
                                            <template>
                                                <v-list-tile-avatar>
                                                    <img :src="data.item.photo" />
                                                </v-list-tile-avatar>
                                                <v-list-tile-content>
                                                    <v-list-tile-title v-html="data.item.combined_name"></v-list-tile-title>
                                                    <v-list-tile-sub-title v-html="data.item.primary_email_address"></v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </template>
                                        </template>
                                    </bc-combobox>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="email_info.subject"
                                        :label="$t('lang.subject')"
                                        :counter="showCounter(email_info.subject, 'email_info.subject')"
                                        :rules="ifValid('email_info.subject')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <vue-editor v-model="email_info.message" :editor-toolbar="customToolbar"></vue-editor>
                                </v-flex>
                                <v-flex xs12>
                                    <div style="display: flex">
                                        <v-chip color="white" style="border-radius: 5px" class="body-2 black--text ml-0" disabled>
                                            <span>Attached Files ({{ email_info.files.length > 0 ? email_info.files.length + 1 : 1 }}):</span>
                                        </v-chip>
                                        <v-chip color="primary" style="border-radius: 5px" class="body-2 white--text" disabled>
                                            <span>{{ pdfReportName }}</span>
                                        </v-chip>
                                        <v-chip
                                            v-for="(file, index) in email_info.files"
                                            color="primary"
                                            style="border-radius: 5px"
                                            class="body-2 white--text"
                                            disabled
                                        >
                                            <span>{{ file.name }}</span>
                                            <v-icon small class="ml-2" style="cursor: pointer" @click="removeFile(index)">cancel</v-icon>
                                        </v-chip>
                                    </div>
                                </v-flex>
                                <v-flex xs12>
                                    <div class="dropzone" @dragenter.prevent @dragover.prevent @drop="handleFileDrop" @click="$refs.upload_file.click()">
                                        <p>Drag and drop files here</p>
                                    </div>
                                    <input ref="upload_file" style="display: none" type="file" multiple="true" @change="handleFileSelect" />
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto"></div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { VueEditor } from "vue2-editor";
import AppConfig from "Constants/AppConfig";
import axios from "axios";
//TODO: custom filter for the v-combo to search for email as well as name
export default {
    components: {
        VueEditor,
    },
    props: ["fileName", "workOrderId", "pdfReportName", "endPoint"],
    data() {
        return {
            email_dialog: false,
            email_info: {
                from: "",
                to: [],
                cc: [],
                bcc: [],
                subject: "",
                message: "",
                files: [],
            },
            to_search: "",
            cc_search: "",
            bcc_search: "",
            to_displayed_email: [],
            cc_displayed_email: [],
            bcc_displayed_email: [],
            addBcc: false,
            customToolbar: [
                // [{ font: [] }],

                [{ header: [false, 1, 2, 3, 4, 5, 6] }],

                // [{ size: ["small", false, "large", "huge"] }],

                ["bold", "italic", "underline", "strike"],

                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],

                // [{ header: 1 }, { header: 2 }],

                ["blockquote"],

                [{ list: "ordered" }, { list: "bullet" }],

                // [{ script: "sub" }, { script: "super" }],

                [{ indent: "-1" }, { indent: "+1" }],

                [{ color: [] }, { background: [] }],

                ["link", "image"],

                // [{ direction: "rtl" }],
                ["clean"],
            ],
        };
    },
    computed: {
        ...mapState({
            rules_email_info: (state) => state.notifications.rules_email_info,
            people: (state) => state.people.people_with_emails,
            people_options: (state) => state.people.person_options,
        }),
    },
    methods: {
        ...mapActions(["createEmail", "fetchPeople"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        email_filter(item, queryText, itemText) {
            return (item.combined_name || "").toLowerCase().includes(queryText) || (item.primary_email_address || "").toLowerCase().includes(queryText);
        },
        validNewEmail(email_type) {
            if (email_type == "to") {
                return this.$r.emailRegex.test(this.to_search);
            } else if (email_type == "cc") {
                return this.$r.emailRegex.test(this.cc_search);
            } else if (email_type == "bcc") {
                return this.$r.emailRegex.test(this.bcc_search);
            }
        },
        remove(item, email_type) {
            if (email_type == "to") {
                const index = this.email_info.to.indexOf(item.primary_email_address);
                if (index >= 0) {
                    this.to_displayed_email.splice(index, 1);
                    this.email_info.to.splice(index, 1);
                }
            } else if (email_type == "cc") {
                const index = this.email_info.cc.indexOf(item.primary_email_address);
                if (index >= 0) {
                    this.cc_displayed_email.splice(index, 1);
                    this.email_info.cc.splice(index, 1);
                }
            } else if (email_type == "bcc") {
                const index = this.email_info.bcc.indexOf(item.primary_email_address);
                if (index >= 0) {
                    this.bcc_displayed_email.splice(index, 1);
                    this.email_info.bcc.splice(index, 1);
                }
            }
        },
        removeFile(index) {
            this.email_info.files.splice(index, 1);
        },
        validateEmail(emails, email_type) {
            if (email_type == "to") {
                this.email_info.to = [];
                emails.forEach((email, key) => {
                    if (email.primary_email_address) {
                        this.email_info.to.push(email.primary_email_address);
                    } else {
                        if (!this.$r.emailRegex.test(email)) {
                            //not valid email format
                            this.to_displayed_email.splice(key, 1); //POSSIBLEDO: dont remove if back format so they can try to fix if trying to add email
                        } else {
                            let adjusted = {
                                primary_email_address: email,
                                photo: AppConfig.baseApiUrl + "/public/users/default.png",
                            };
                            this.email_info.to.push(email);
                            this.to_displayed_email[key] = adjusted;
                        }
                    }
                });
            } else if (email_type == "cc") {
                this.email_info.cc = [];
                emails.forEach((email, key) => {
                    if (email.primary_email_address) {
                        this.email_info.cc.push(email.primary_email_address);
                    } else {
                        if (!this.$r.emailRegex.test(email)) {
                            //not valid email format
                            this.cc_displayed_email.splice(key, 1); //POSSIBLEDO: dont remove if back format so they can try to fix if trying to add email
                        } else {
                            let adjusted = {
                                primary_email_address: email,
                                photo: AppConfig.baseApiUrl + "/public/users/default.png",
                            };
                            this.email_info.cc.push(email);
                            this.cc_displayed_email[key] = adjusted;
                        }
                    }
                });
            } else if (email_type == "bcc") {
                this.email_info.bcc = [];
                emails.forEach((email, key) => {
                    if (email.primary_email_address) {
                        this.email_info.bcc.push(email.primary_email_address);
                    } else {
                        if (!this.$r.emailRegex.test(email)) {
                            //not valid email format
                            this.bcc_displayed_email.splice(key, 1); //POSSIBLEDO: dont remove if back format so they can try to fix if trying to add email
                        } else {
                            let adjusted = {
                                primary_email_address: email,
                                photo: AppConfig.baseApiUrl + "/public/users/default.png",
                            };
                            this.email_info.bcc.push(email);
                            this.bcc_displayed_email[key] = adjusted;
                        }
                    }
                });
            }
        },
        printReport: function (url) {
            printJS({ printable: url, type: "pdf" });
        },
        async sendEmail() {
            let newFileObjects = [];
            let reader = new FileReader();
            for (let i = 0; i < this.email_info.files.length; i++) {
                newFileObjects[i] = {
                    name: this.email_info.files[i].name,
                    type: this.email_info.files[i].type,
                    size: this.email_info.files[i].size,
                    file: "",
                };
                const dataURL = await readFileAsDataURL(this.email_info.files[i]);
                newFileObjects[i].file = dataURL;
            }

            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("emailForm")) {
                    let body = {};
                    body.to = this.email_info.to;
                    body.cc = this.email_info.cc;
                    body.bcc = this.email_info.bcc;
                    body.subject = this.email_info.subject;
                    body.message = this.email_info.message;
                    body.files = newFileObjects;

                    this.createEmail({
                        body: body,
                        endpoint: this.endPoint,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.send_report) {
                            this.email_dialog = false;
                            this.email_info = {
                                from: "",
                                to: [],
                                cc: [],
                                bcc: [],
                                subject: "",
                                message: "",
                                files: [],
                            };
                            this.to_search = "";
                            this.cc_search = "";
                            this.bcc_search = "";
                            this.to_displayed_email = [];
                            this.cc_displayed_email = [];
                            this.bcc_displayed_email = [];
                            //this.$router.push({ name: "notification", params: { id: data.notification.notification_id } });
                        }
                    });
                }
            });
        },
        handleFileSelect(event) {
            const selectedFiles = event.target.files;
            for (let i = 0; i < selectedFiles.length; i++) {
                this.email_info.files.push(selectedFiles[i]);
            }
        },
        handleFileDrop(event) {
            event.preventDefault();
            const selectedFiles = event.dataTransfer.files;
            for (let i = 0; i < selectedFiles.length; i++) {
                this.email_info.files.push(selectedFiles[i]);
            }
        },
        showEmail() {
            this.email_dialog = true;
            if (this.current_user.login_type == "employee") {
                if (this.people_options.length == 0) this.fetchPeople({ body: { options: 1, has_email: 1 } }); // this.$store.dispatch("fetchPeople", { body: { options: 1 } });
            }
        },
    },
    mounted() {
        this.email_dialog = false;
    },
};

function readFileAsDataURL(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = reject;
    });
}
</script>
<style>
.v-text-field {
    margin-top: 0px !important;
}
.v-input__slot {
    margin-bottom: 0px !important;
}
.dropzone {
    width: 100%;
    height: 200px;
    border: 2px dashed grey !important;
    text-align: center;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.dropzone * {
    cursor: pointer;
}
.ql-container {
    height: auto !important;
    min-height: 250px !important;
}
</style>
